import React, { useState, useEffect, useImperativeHandle, useRef } from "react";
import styled from "styled-components";
import { mdiCheck, mdiMinus } from "@mdi/js";
import { Svg } from "./Svg";

const CheckboxStyle = styled.div`
`;

const ContainerStyle = styled.div`
    height: 26px;
    display: flex;
    align-items: center;
`;

const RectangleStyle = styled.button`
    cursor: pointer;
    padding: 0;
    width: 22px;
    height: 22px;
    user-select: none;
    border-radius: 2px;
    background: ${props => props.theme.white};
    border: 1px solid ${props => props.theme.greyLight};
    &:focus {
        border-color: ${props => props.theme.white};
        outline: 1px solid ${props => props.theme.primaryLight};
    }
    &.disabled {
        pointer-events: none;
        border: 1px solid ${props => props.theme.greyLight};
        background-color: ${props => props.theme.greyLighter};
        >svg {
            fill: ${props => props.theme.greyDarker};
        }
    }
    >svg {
        pointer-events: none;
        fill: ${props => props.theme.black};
    }
`;

const TitleStyle = styled.p`
    height: 12px;
    font-size: 12px;
    user-select: none;
    margin-bottom: 1px;
    letter-spacing: 0.4px;
    color: ${props => props.theme.black};
`;

export const Checkbox = props => {

    const { id, ref, name, title, value, disabled, indeterminate } = props;

    const inputRef = useRef(null);
    const [checked, setChecked] = useState(value);
    const className = disabled ? "disabled" : "";

    useImperativeHandle(ref, () => ({
        get value() {
            return value;
        },
        focus: () => inputRef.current.focus(),
    }), [inputRef, value]);

    useEffect(() => {
        setChecked(value);
    }, [value]);

    const onClick = () => {
        props.onChange(!checked);
    };

    return (
        <CheckboxStyle>
            {title !== false &&
                <TitleStyle>{title}</TitleStyle>
            }
            <ContainerStyle>
                <RectangleStyle
                    id={id}
                    name={name}
                    ref={inputRef}
                    onClick={onClick}
                    className={className}
                    tabIndex={disabled ? -1 : 0}>
                    {checked &&
                        <Svg path={mdiCheck} size="20" />
                    }
                    {!checked && indeterminate &&
                        <Svg path={mdiMinus} size="20" />
                    }
                </RectangleStyle>
            </ContainerStyle>
        </CheckboxStyle>
    );
};
